import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const DivisionCard = ({
    icon: Icon,
    logoSrc,
    logoAlt,
    logoWide = false,
    logoPad = "p-2",
    title,
    tagline,
    description,
    cta,
    href,
    external = false,
    className = "",
    "data-testid": testId,
}) => {
    const slotCls = logoWide
        ? `flex h-14 w-auto max-w-[160px] items-center justify-center rounded-xl bg-[var(--bg-elevated-2)] border border-border-subtle ${logoPad}`
        : `flex h-14 w-14 items-center justify-center rounded-xl bg-[var(--bg-elevated-2)] border border-border-subtle ${logoPad}`;
    const content = (
        <>
            <div className="flex items-start justify-between gap-3">
                <div className={slotCls} aria-hidden>
                    {logoSrc ? (
                        <img
                            src={logoSrc}
                            alt={logoAlt || ""}
                            loading="lazy"
                            className="block h-full w-auto object-contain"
                        />
                    ) : (
                        <Icon
                            className="h-6 w-6 text-[var(--accent)]"
                            strokeWidth={1.5}
                        />
                    )}
                </div>
                {tagline && (
                    <span className="text-[11px] uppercase tracking-widest-2 text-text-muted whitespace-nowrap">
                        {tagline}
                    </span>
                )}
            </div>

            <div className="mt-8">
                <h3 className="font-display text-[24px] font-semibold leading-tight text-text-primary">
                    {title}
                </h3>
                <p className="mt-3 text-[15px] leading-[1.65] text-text-secondary max-w-[44ch]">
                    {description}
                </p>
            </div>

            <div className="mt-10 inline-flex items-center gap-1.5 text-[14px] font-medium text-text-primary group-hover:text-[var(--accent)] transition-colors duration-300">
                <span>{cta}</span>
                <ArrowUpRight
                    className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    strokeWidth={1.5}
                />
            </div>
        </>
    );

    const cls = `zen-card group relative flex h-full flex-col rounded-2xl border border-border-subtle bg-elevated p-8 lg:p-9 ${className}`;

    if (external) {
        return (
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className={cls}
                data-testid={testId}
            >
                {content}
            </a>
        );
    }
    return (
        <Link to={href} className={cls} data-testid={testId}>
            {content}
        </Link>
    );
};

export default DivisionCard;
